module.exports = __webpack_public_path__ + "static/media/8.aa020ec6.jpg";